import { render, staticRenderFns } from "./ImabScore.vue?vue&type=template&id=24daab21&"
import script from "./ImabScore.vue?vue&type=script&lang=js&"
export * from "./ImabScore.vue?vue&type=script&lang=js&"
import style0 from "./ImabScore.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports